import { extend } from 'vee-validate';
import i18n from '@/locales/i18n';
import { required, email } from 'vee-validate/dist/rules';

extend('usernameRequired', {
	...required,
	message: () => i18n.t('usernameRequired'),
});

extend('passwordRequired', {
	...required,
	message: () => i18n.t('passwordRequired'),
})

extend('atleastLowercase', {
	validate(value) {
		const containsAtleastLowercase = new RegExp(/[a-z]/);
		return containsAtleastLowercase.test(value);
	},
	message: () => i18n.t('atleastLowercase'),
});

extend('atleastNumber', {
	validate(value) {
		const containsAtleastNumber = new RegExp(/[0-9]/);
		return containsAtleastNumber.test(value);
	},
	message: () => i18n.t('atleastNumber'),
});

extend('atleastUnderscore', {
	validate(value) {
		const containsAtleastUnderscore = new RegExp(/_/);
		return containsAtleastUnderscore.test(value);
	},
	message: () => i18n.t('atleastUnderscore'),
});

extend('notContainsSpecialChars', {
	validate(value) {
		const notContainsSpecialChars = new RegExp(/^[a-zA-Z0-9_]+$/);
		return notContainsSpecialChars.test(value);
	},
	message: () => i18n.t('notContainsSpecialChars'),
});

extend('doesNotBeginOrEndWithUnderscore', {
	validate(value) {
		const doesNotBeginOrEndWithUnderscore = new RegExp(/^(?!_).*[^_]$/);
		return doesNotBeginOrEndWithUnderscore.test(value);
	},
	message: () => i18n.t('doesNotBeginOrEndWithUnderscore'),
});

extend('atleastUppercase', {
	validate(value) {
		const atleastUppercase = new RegExp(/[A-Z]/);
		return atleastUppercase.test(value);
	},
	message: () => i18n.t('atleastUppercase'),
});

extend('notContainsSpace', {
	validate(value) {
		const notContainsSpace = new RegExp(/^\S*$/);
		return notContainsSpace.test(value);
	},
	message: () => i18n.t('notContainsSpace'),
});

extend('doesNotContainUppercase', {
	validate(value) {
		const doesNotContainUppercase = new RegExp(/^[^A-Z]*$/);
		return doesNotContainUppercase.test(value);
	},
	message: () => i18n.t('doesNotContainUppercase'),
});

extend('confirmPassword', {
	params: ['target'],
	validate(value, { target }) {
		return value === target;
	},
	message: () => i18n.t('confirmPasswordMatchError'),
});

extend('containsAtleastOneSpecialChar', {
	validate(value) {
		const containsAtleastOneSpecialChar = new RegExp(/[!@#$%^&*(),.?"'`:;{}|<>_\-+=/"\[\]~\\]/);
		return containsAtleastOneSpecialChar.test(value);
	},
	message: () => i18n.t('containsAtleastOneSpecialChar'),
});

extend('minUsernameLength', {
	params: ['target'],
	validate(value, { target }) {
		const length = value.length;
		return (length >= target || !target)
	},
	message: () => i18n.t('minUsernameLength'),
});

extend('maxUsernameLength', {
	params: ['target'],
	validate(value, { target }) {
		const length = value.length;
		return (length <= target || !target)
	},
	message: () => i18n.t('maxUsernameLength'),
});

extend('minPasswordLength', {
	params: ['target'],
	validate(value, { target }) {
		const length = value.length;
		return (length >= target || !target)
	},
	message: () => i18n.t('minPasswordLength'),
});

extend('maxPasswordLength', {
	params: ['target'],
	validate(value, { target }) {
		const length = value.length;
		return (length <= target || !target)
	},
	message: () => i18n.t('maxPasswordLength'),
});


extend('usernameSignupRequired', {
	...required,
	message: () => i18n.t('usernameSignupRequired'),
});

extend('passwordSignupRequired', {
	...required,
	message: () => i18n.t('passwordSignupRequired'),
});

extend('confirmPasswordSignupRequired', {
	...required,
	message: () => i18n.t('confirmPasswordSignupRequired'),
});

extend('emailSignupRequired', {
	...required,
	message: () => i18n.t('emailSignupRequired'),
})

extend('emailSignuValid', {
	...email, 
	message: () => i18n.t('emailSignuValid'),
})

extend('emailSignuLatinValid', {
	validate(value) {
		//check only latin characters are allowed
		const emailSignuLatinValid = new RegExp(/^[a-zA-Z0-9.]+(?!-.)@[a-zA-Z0-9.-]+$/);

		return emailSignuLatinValid.test(value);
	},
	message: () => i18n.t('emailSignuValid'),
})

extend('newModelNameRequired', {
	...required,
	message: () => i18n.t('newModelNameRequired'),
})